// extracted by mini-css-extract-plugin
module.exports = {"bg":"Loading_bg__12vrE","Starting":"Loading_Starting__3lLOy","fadein":"Loading_fadein__1ebiq","leaves":"Loading_leaves__Tjo-r","SimpleLoading":"Loading_SimpleLoading__1ql1h"};